export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdEdtDms_mlp_log';
export const NAME = 'MobilniZarizeni';

export const COLUMN_POZNAMKA = 'POZNAMKA';
export const COLUMN_CHECKBOX = 'CHECKBOX';
